import React from "react";
import {
  Alert,
  Button,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import { NavLink } from "react-router-dom";

import { useLoginFormik } from "./lib/useLoginFormik";
import { useAuthContext } from "../../lib/context/AuthContext/AuthContext";

import { CenteredBox } from "../../components/CenteredBox/CenteredBox";

import "./Login.scss";

export const Login = () => {
  const authCtx = useAuthContext();

  const formik = useLoginFormik({
    initialValues: {
      username: "",
      password: "",
    },
    onSubmit: async (values, formikHelpers) => {
      authCtx.login(values.username, values.password);
    },
  });

  return (
    <div className="Login w-100 h-100 align-items-center justify-center">
      <CenteredBox constant="GOGET Internal tool">
        <Form
          onSubmit={formik.handleSubmit}
          className="Contact__form d-flex flex-column w-100 p-4"
        >
          {authCtx.message.text && (
            <Alert color={authCtx.message.type}>{authCtx.message.text}</Alert>
          )}
          <FormGroup>
            <Label for="username">Username</Label>
            <Input
              type="text"
              id="username"
              name="username"
              value={formik.values.username}
              onChange={formik.handleChange}
              invalid={!!formik.errors.username && formik.touched.username}
            />
            <FormFeedback>{formik.errors.username}</FormFeedback>
          </FormGroup>
          <FormGroup className="mb-1">
            <Label for="password">Password</Label>
            <Input
              type="password"
              id="password"
              name="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              invalid={!!formik.errors.password && formik.touched.password}
            />
            <FormFeedback>{formik.errors.password}</FormFeedback>
          </FormGroup>
          <NavLink className="mb-3 d-inline-block ml-auto" to="/reset-password">
            Forgot your password?
          </NavLink>
          <Button
            disabled={authCtx.loading}
            type="submit"
            color="primary"
            className="w-100"
          >
            {authCtx.loading ? "Loading" : "Login"}
          </Button>
        </Form>
      </CenteredBox>
    </div>
  );
};
